import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { axiosPrivate } from '../api/api';

const RequireAuth = ({ navigate }) => {
	const [verified, setVerified] = useState(false);
	const [loading, setLoading] = useState(true);
	const location = useLocation();

	const verifyCookie = async () => {
		setLoading(true);
		try {
			const response = await axiosPrivate.get('/verifyCookie');
			if (response.status === 200) {
				if (response.data?.auth_cpt) window.localStorage.setItem('cpt_auth', response.data.auth_cpt);
				if (response.data?.username) window.localStorage.setItem('username', response.data.username);
				if (response.data?.ghostBy) window.localStorage.setItem('ghostBy', response.data.ghostBy);
				else window.localStorage.removeItem('ghostBy');
				setVerified(true);
			} else {
				setVerified(false);
			}
		} catch (error) {
			console.log(error);
			setVerified(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		verifyCookie();
	}, [location.pathname]);
	
	if (loading) {
		return null;
	}
	if (verified) {
		return <Outlet />;
	} else {
		return <Navigate to='/' state={{ from: location }} replace />;
	}
};

export default RequireAuth;
